import React from "react";
import { Typography } from "antd";
const { Text } = Typography;
import { useTranslation } from "react-i18next";

const AllClaimsPageCount = ({ range, total }) => {
  const { t } = useTranslation();
  const title = t("all_claims_pagination.title");

  return (
    <>
      <Text>
        {t("all_claims_pagination.showing_range", {
          range_start: range[0],
          range_end: range[1] ? range[1] : range[0],
          total: total
        })}{" "}
        <Text strong>{title}</Text>
      </Text>
    </>
  );
};

export default AllClaimsPageCount;
